/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

import ProfileModel from '../../models/ProfileModel';
import { ListItem } from '../../apiServices/ListsService';

interface Props {
  intl: any;
  bloodTypeCollection: ListItem[];
  getInitialData(): void;
  profile: ProfileModel;
}

class LocalizedBloodType extends React.Component<Props, {}> {
  render() {
    const { profile, bloodTypeCollection } = this.props;
    const bloodType = bloodTypeCollection.find(i => i.id === profile.data.blood_type_id);
    const messageKey = bloodType && bloodType.key;

    if (!messageKey) return <span/>;
    return <FormattedMessage id={messageKey} />;
  }

  UNSAFE_componentWillMount() {
    if (this.props.getInitialData) {
      this.props.getInitialData();
    }
  }
}

export default injectIntl(LocalizedBloodType);
